import React from "react";
import { getEnv } from "../helpers";
const STOCKWAVE_SCRIPT_SRC_QA = "https://stockwave.partners-np.vauto.com/ias/1/integration.js";
const STOCKWAVE_SCRIPT_SRC_PROD = "https://stockwave.partners.vauto.com/ias/1/integration.js";
const STOCKWAVE_SCRIPT_ID = "stockwave-integration-src";
const STOCKWAVE_SCRIPT_TYPE = "text/javascript";

export const stockwaveClassNames = {
    bidButton: "stockwave-bid-button",
    buyButton: "stockwave-buy-button",
    bidBuyAmount: "stockwave-bid-buy-amount",
    highlight: "stockwave-highlight-element",
    lightbulb: "stockwave-light-bulb-container",
    srpVehicleInfo: "stockwave-vehicle-info",
    srpVehicleRow: "stockwave-vehicle-row",
    vdpVehicleDetails: "stockwave-vehicle-details",
    vin: "stockwave-bid-buy-vin",
}

export const addStockwaveScript = (enableStockwave=false) => {
    const stockwaveScriptSrc = (getEnv() === 'production') ? STOCKWAVE_SCRIPT_SRC_PROD : STOCKWAVE_SCRIPT_SRC_QA;
    const existingScript = document.head.querySelector(`#${STOCKWAVE_SCRIPT_ID}`);
    if (!existingScript && [true, 'true'].includes(enableStockwave)) {
        const script = document.createElement('script');
        script.src = stockwaveScriptSrc;
        script.id = STOCKWAVE_SCRIPT_ID;
        script.type = STOCKWAVE_SCRIPT_TYPE;
        script.defer = true;
        script.onload = initializeStockwave;
        document.head.appendChild(script);
    }
}

function initializeStockwave() {
    try {
        const stockwaveScript = document.head.querySelector(`#${STOCKWAVE_SCRIPT_ID}`);
        if (stockwaveScript && window.stockwave && typeof window.stockwave.initialize === 'function') {
            window.stockwave.initialize();
        } else {
            console.warn('Stockwave script not found or stockwave.initialize is not a function.');
        }

    } catch (initiStockwaveError) {
        console.error('Error initializing Stockwave:', initiStockwaveError);
    }
}